// Reusable Edge reveal model: turns a graded tap task into what the learner got
// right and what needs correcting. It is driven entirely by data — the element,
// the learner's actual tap and the element's true position — and knows nothing
// about candles. Each Read supplies two functions:
//
//   anchorOf(promptId, tap) -> the true position of that element, in data
//                          units (the tap lets an element with more than one
//                          instance, like a wick, pick the one meant); it may
//                          carry its own `place` name, used instead of describe
//   describe(point)     -> { short, long, y? } plain-language name of a position
//                          ("Top of body" / "the top of the body"), and the
//                          exact price of that named position when it has one
//
// Every marker the reveal draws comes from these values; nothing is placed by
// eye. A later Read (swing highs, support/resistance) passes its own anchorOf
// and describe and reuses the reveal screens unchanged.
export function buildReveal(prompts, results, { anchorOf, describe }) {
  const correct = [];
  const mistakes = [];
  prompts.forEach((p) => {
    const r = results.byId[p.id];
    if (r.correct) {
      correct.push({ id: p.id, label: p.label, tap: r.answer });
      return;
    }
    const anchor = anchorOf(p.id, r.answer);
    const yourPlace = describe(r.answer);
    mistakes.push({
      id: p.id,
      label: p.label,
      tap: r.answer,
      // Where "Your answer" is drawn: on the named position the tap falls in
      // ("Top of body"), otherwise at the tap's own price.
      mark: yourPlace.y != null ? { x: r.answer.x, y: yourPlace.y } : r.answer,
      anchor,
      yourPlace,
      correctPlace: anchor.place || describe(anchor),
    });
  });
  return { correct, mistakes, total: prompts.length };
}
